import { render } from "./WhyNeed.vue?vue&type=template&id=00763ff6&scoped=true"
import script from "./WhyNeed.vue?vue&type=script&lang=js"
export * from "./WhyNeed.vue?vue&type=script&lang=js"

import "./WhyNeed.vue?vue&type=style&index=0&id=00763ff6&scoped=true&lang=css"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00763ff6"]])

export default __exports__